import { get, post } from '@/utils';
import { fetchProjectImages } from '@/hooks/fetch-hooks/use-projects-v2/actions';
import { ShareTip } from './context';

// ==============================|| CITYZEN - SHARE API (cityzen-be-v2: api/shares) ||============================== //
// GET api/shares/{type}/{id} — meta OG efectiv (override salvat sau default-ul entității)
// + linkul canonic; FĂRĂ efecte de analytics — sigur de apelat la deschiderea dialogului.
// POST api/shares — înregistrează distribuirea (ShareCount/eventuri), PERSISTĂ
// personalizarea (ogTitle/ogDescription/ogImageId) și întoarce meta efectiv.

// valorile EXACTE din ShareEntityTypes (be-v2) — set case-sensitive, plural lowercase
const SHARE_TYPE_BY_TIP: Record<ShareTip, string> = {
	proiect: 'projects',
	anunt: 'announcements',
	chestionar: 'surveys'
};

export interface ShareDetails {
	url: string;
	ogTitle: string;
	ogDescription?: string | null;
	ogImageId?: number | null;
	ogImageUrl?: string | null;
}

export interface ShareOverrides {
	ogTitle?: string;
	ogDescription?: string;
	/** Id-ul assetului pozei alese; null = revenire la poza default a entității. */
	ogImageId?: number | null;
}

export async function getShareDetails(
	tip: ShareTip,
	id: string | number
): Promise<ShareDetails> {
	const res = await get(`api/shares/${SHARE_TYPE_BY_TIP[tip]}/${Number(id)}`);
	const details = res.data as ShareDetails;
	if (!details?.url)
		throw new Error('Detaliile de distribuire nu au putut fi încărcate.');
	return details;
}

export async function createShare(
	tip: ShareTip,
	id: string | number,
	overrides: ShareOverrides
): Promise<ShareDetails> {
	const res = await post('api/shares', {
		type: SHARE_TYPE_BY_TIP[tip],
		id: Number(id),
		...overrides
	});
	const details = res.data as ShareDetails;
	if (!details?.url) throw new Error('Linkul de distribuire nu a putut fi generat.');
	return details;
}

// Galeria PROIECTULUI ca perechi {id, url} pentru ShareTarget.imageAssets — anunțurile
// și consultările nu au imagini proprii, iar BE-ul le derivă OG-ul tot din asset-urile
// proiectului părinte. Best-effort: fără proiect / fără acces → listă goală (dialogul
// rămâne funcțional cu poza salvată + upload).
export async function getProjectImageAssets(
	projectId?: number | null
): Promise<{ id: number; url: string }[]> {
	if (!projectId) return [];
	try {
		return (await fetchProjectImages(projectId)).map((a) => ({
			id: a.id,
			url: a.publicUrl
		}));
	} catch {
		return [];
	}
}
